import { useMemo } from "react";

import { reactKeys } from "@handlewithcare/react-prosemirror";
import { Node } from "prosemirror-model";
import { EditorState } from "prosemirror-state";

import { schema } from "@/ai/components/Editor/schemas";
import { PMJSONNode } from "@/bundles/types/LessonSparkAttachment";

function useEditorStateFromJSON(json?: PMJSONNode): EditorState | undefined {
  return useMemo(() => {
    if (!json) return undefined;
    const doc = Node.fromJSON(schema, json);
    return EditorState.create({ schema, doc, plugins: [reactKeys()] });
  }, [json]);
}

export default useEditorStateFromJSON;
